import React, { PureComponent } from 'react'
import { DeleteOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons'
import styles from './style.module.less'
import cls from 'classnames'
// import ClipModal from './ClipModal'
// import ClipModal from '@hlj/hlj-components/esm/ClipModal'
import { ClipModal } from '@hlj/hlj-components'
import SetVerticalModal from '@common/SetVerticalImgModal'

export default class extends PureComponent {
  uploader
  fileId
  file
  static defaultProps = {
    multiple: false,
    width: 320,
    height: 180,
    value: '',
    showDelete: true,
    showEye: true,
    disabled: false,
    autoSizeError: false,
    //设置target='_blank'时点击预览会跳转到新页面显示点击的图片且onPreview失效
    target: '_self',
    autoSuffix: true,
    uptoken_url: 'image_upload_token',
    autoCut: false
  }
  state = {
    isActive: false,
    previewModal: false,
    clipLink: this.props.value, // 用于裁剪显示
    verticalImgVisible: false,
    clipConfig: null,
    pixelCrop: {}
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ clipLink: this.props.value })
    }
  }

  toggleVisible = bool => e => {
    this.setState({
      verticalImgVisible: bool
    })
  }

  onCliped = (v, info) => {
    const clipInfo = typeof v === 'string' ? info : v
    const { clipUrl, crop, pixel } = clipInfo
    this.setState({
      clipConfig: crop,
      pixelCrop: pixel
    })
    const { onChange, onCliped, afterCliped } = this.props
    onChange && onChange(clipUrl)
    onCliped && onCliped(clipInfo)
    this.toggleVisible(false)()
    afterCliped && afterCliped(clipInfo)
  }

  onDelete = () => {
    const { onChange, onDelete } = this.props
    onChange && onChange('')
    onDelete && onDelete()
  }

  preview = type => {
    /**
     * 如是裁剪取消触发，且重新上传过文件
     * 则将裁剪 url 重置回之前的 value
     */
    if (type === 'cancel' && this.props.value !== this.state.clipLink) {
      this.setState({ clipLink: this.props.value })
    }

    if (this.props.onPreview) {
      this.props.onPreview(this.props.value)
    } else {
      this.setState({
        previewModal: !this.state.previewModal
      })
    }
  }

  hover = type => () => {
    const { children, disabled } = this.props
    if (!children && !disabled) {
      if (type === 'out' && this.state.isActive) {
        this.setState({
          isActive: false
        })
      } else if (this.props.value) {
        this.setState({
          isActive: true
        })
      }
    }
  }

  render() {
    let { isActive, previewModal, clipConfig, pixelCrop } = this.state
    const {
      width,
      height,
      style,
      value,
      showDelete,
      showEye,
      children,
      disabled,
      target,
      description,
      aspect,
      horizonImg,
      title,
      hidePlusIcon,
      uploadConfig,
      autoCut,
      limitWidth,
      limitHeight
    } = this.props

    let warpStyle = {
      width: children ? 'auto' : width || 160,
      height: children ? 'auto' : height || 120,
      display: 'inline-block',
      padding: '0 15px 0 15px'
    }
    return (
      <>
        <div
          onMouseOver={this.hover('over')}
          onMouseOut={this.hover('out')}
          onClick={this.toggleVisible(true)}
          className={styles.upbox}
          style={{ ...warpStyle, ...style }}
        >
          <div className={styles.upbut}>
            {children ? (
              <div className={styles.up_text}>{children}</div>
            ) : !value ? (
              <span className={styles.upload_mark}>
                {!hidePlusIcon && (
                  <PlusOutlined className={styles.upload_icon} />
                )}
                {description && (
                  <div className={styles.upload_description}>{description}</div>
                )}
              </span>
            ) : (
              <img
                style={{ height, width }}
                className={styles.upimg}
                src={
                  value.indexOf('?') != -1
                    ? value + `|imageView2/1/h/${height * 2}/w/${width * 2}`
                    : value + `?imageView2/1/h/${height * 2}/w/${width * 2}`
                }
              />
            )}
          </div>
          {disabled && <div className={styles.disabled} />}
          {!children && (
            <span
              className={cls({
                [styles.delete]: true,
                [styles.active]: isActive
              })}
              onClick={e => e.stopPropagation()}
            >
              {showEye && (
                <span
                  onClick={
                    target === '_blank' ? undefined : () => this.preview('clip')
                  }
                >
                  {target === '_blank' ? (
                    <a
                      style={{ color: '#fff' }}
                      rel="noopener noreferrer"
                      target="_blank"
                      href={value}
                    >
                      <EyeOutlined />
                    </a>
                  ) : (
                    <EyeOutlined />
                  )}
                </span>
              )}
              {showDelete && (
                <span onClick={this.onDelete}>
                  <DeleteOutlined />
                </span>
              )}
            </span>
          )}
          <div onClick={e => e.stopPropagation()}>
            {previewModal && (
              <ClipModal
                aspect={aspect}
                clipConfig={clipConfig}
                pixelCrop={pixelCrop}
                onCliped={this.onCliped}
                visible={previewModal}
                img={this.state.clipLink}
                onCancel={this.preview}
              />
            )}
          </div>
        </div>

        <SetVerticalModal
          limitWidth={limitWidth}
          limitHeight={limitHeight}
          superImage={horizonImg}
          title={title}
          visible={this.state.verticalImgVisible}
          onOk={this.onVerticalImgUploadOk}
          onCancel={this.toggleVisible(false)}
          onCliped={this.onCliped}
          autoCut={this.props.autoCut}
          uploadConfig={{
            aspect,
            autoCut,
            ...uploadConfig
          }}
          clipModalConfig={{
            aspect
          }}
        />
      </>
    )
  }
}
